import React from "react";
import Cta from "@qlik/qlik/src/components/Cta";
import Media from "@qlik/qlik/src/components/Media";
import { getCardDescriptionText, getCardEyebrowText, getCardMedia } from "@qlik/qlik/src/lib/util/helpers";
import * as styles from "./styles.module.css";

/**
 * BannerCTAResources component.
 * Renders a banner with a call to action and resources.
 * @param {Object} props - The component props.
 * @param {Object} props.data - The data for the banner.
 * @returns {JSX.Element} The rendered component.
 */
const BannerCTAResources = ({ data }) => {
    const { cardItem, backgroundImage, customId } = data ?? {};
    const { title, cta } = cardItem ?? {};

    const resourceType = getCardEyebrowText(cardItem);

    const resourceMedia = getCardMedia(cardItem);

    const resourceExcerpt = getCardDescriptionText(cardItem);

    return (
        // Render the BannerCTAResources component
        <section
            className={`promoCardVideo flex items-center bg-ocean overflow-hidden ${styles.section}`}
            id={customId}
        >
            <div className="container">
                <div className="row">
                    <div className="col-12 md:col-6 relative md:flex md:align-middle md:justify-center md:flex-col">
                        <div className="m-auto text-center md:text-left md:ml-0">
                            {resourceType && (
                                <span className="tag-1 block text-white text-sm tracking-wide4 uppercase lg:text-base lg:tracking-wide5">
                                    {resourceType}
                                </span>
                            )}
                            <h2 className="my-3.75 text-white lg:mb-5.5 lg:mt-4.75">{title}</h2>
                            {resourceExcerpt && (
                                <p
                                    className={`mb-7.5 text-sm tracking-tight2 text-white lg:text-2xl lg:font-light lg-font-light lg:tracking-tight6 lg:leading-relaxed ${styles.description}`}
                                >
                                    {resourceExcerpt}
                                </p>
                            )}
                            {cta?.map((button) => (
                                // Render the Cta component for each button
                                <div className="flex gap-2 justify-center md:justify-start" key={button.id}>
                                    <Cta
                                        key={button.id}
                                        data={button}
                                        // eslint-disable-next-line react/jsx-curly-brace-presence
                                        className="py-2 px-7 md:py-3.25 md:px-5.75"
                                    />
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="col-12 md:col-6 mt-12.5 md:mt-0 relative flex items-center justify-center md:justify-end ">
                        <div>
                            <div
                                className={`${styles.backgroundWrapper} left-1/2 -translate-y-1/2 -translate-x-1/2 absolute pointer-events-none mix-blend-color-dodge`}
                            >
                                <span
                                    style={{
                                        backgroundImage: `url(${
                                            backgroundImage?.length > 0 ? backgroundImage?.[0]?.secure_url : "none"
                                        })`,
                                    }}
                                    className="block max-w-[1075px] relative left-1/2 -translate-x-1/2 lg:w-268.75 bg-center bg-contain	bg-no-repeat"
                                />
                            </div>
                            <div className="m-auto relative lg:max-w-[400px]">
                                {resourceMedia && (
                                    // Render the Media component for the media
                                    <Media
                                        media={resourceMedia}
                                        className="object-contain w-full lg:object-cover max-w-none md:max-w-full md:w-auto h-full rounded-2xl"
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default BannerCTAResources;
